module.exports = __webpack_public_path__ + "static/media/4.37ac1608.svg";